import { render, staticRenderFns } from "./listado-etiquetas.vue?vue&type=template&id=2cf24a8f&scoped=true&"
import script from "./listado-etiquetas.vue?vue&type=script&lang=ts&"
export * from "./listado-etiquetas.vue?vue&type=script&lang=ts&"
import style0 from "./listado-etiquetas.vue?vue&type=style&index=0&id=2cf24a8f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf24a8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDialog,VList,VListItem,VListItemGroup,VRow})
